export enum CrTypeEnum {
    Internal = 30,
    External = 31
  }
  export enum FranchiseTypeEnum {
    Main = 40,
    Normal = 41
  }
  export enum ReferenceTypeEnum {
    CrName = 92,
    Trademark = 93
  }
  export enum AdminLookupCategory {
    RequestType = 1,
    RequestStatus = 2
  }